import { formatCurrency, formatPhone } from '@recargas-dominicanas/core/utils';
import type { IProduct, InsurancePlan, InsuranceVehicle } from '@recargas-dominicanas/core/types';
import { DetailModal } from '../detail-modal/detail-modal.component';
import { DetailModalItem } from '../detail-modal-item/detail-modal-item.component';

import { 
  ModalContent,
  ModalActions, 
  Button, 
  OutlineButton
} from '@recargas-dominicanas/core/components';

interface Props {
  open: boolean;
  product: IProduct;
  vehicle: InsuranceVehicle;
  plan: InsurancePlan;
  chassis: string;
  docNumber: string;
  phone: string;
  onAccept: () => void;
  onClose: () => void;
}

export function InsuranceConfirmModal(props: Props) {

  const {
    open,
    product,
    vehicle,
    plan,
    chassis,
    docNumber,
    phone,
    onAccept,
    onClose
  } = props;

  const vigency = parseInt(plan.vigency);

  return (
    <DetailModal
      open={open} 
      title='Comprar seguro de ley'
      overlayEnterAnimation={false}>
      <ModalContent>
        <DetailModalItem title='Compañía' text={product.name}/>
        <DetailModalItem title='Vehiculo' text={vehicle.name}/>
        <DetailModalItem title='Chasis' text={chassis}/>
        <DetailModalItem title='Plan' text={plan.name}/>
        <DetailModalItem title='Vigencia' text={`${vigency} ${vigency === 1 ? 'Mes' : 'Meses'}`}/>
        <DetailModalItem title='Precio' color='green' text={formatCurrency(plan.price)}/>
        <DetailModalItem title='Cédula' text={docNumber}/>
        <DetailModalItem title='Télefono' text={formatPhone(phone)}/>
      </ModalContent>
      <ModalActions>
        <Button text='Cancelar' onClick={onClose}/>
        <OutlineButton text='Comprar' onClick={onAccept} />
      </ModalActions>
    </DetailModal>
  );
}
